module.exports = __webpack_public_path__ + "img/casper_1.94a62ec7.gif";